export const isFiniteVector3Array = (value: unknown): value is [number, number, number] =>
  Array.isArray(value) &&
  value.length >= 3 &&
  value.slice(0, 3).every((item) => Number.isFinite(Number(item)));
